import app from '@frontend/application-container';
import { SettingsEntry } from '../settings-entry';
import { FormNumber } from '@components/form';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/set_coordinate_decimals.svg';
import { img } from '@phi/components';
import { h } from 'vue';

export const CoordinateDecimalsIcon = icon;

export function CoordinateDecimals() {
    return SettingsEntry(
        'Decimal places',

        'Set the number of decimal places to display for coordinates.',

        img(icon, 'Decimal places'),

        h(FormNumber, {
            value: app.settings.coordinate_decimals,
            'onUpdate:value': x => app.settings.coordinate_decimals = x,
            change: true,
        }),
    );
}
